import componentDisplay from "../../../../componentDisplay";
import UTC2Local, { formatDateTimeToString } from "../../../../UTC2Local";

export const getTable = (actions) => {
    return {
      columns: [
        {
          id: "resourceName",
          label: "exportExcel.list.column.resourceName",
          align: "left",
          visible: true,
          renderCell: (row) => {
            return row?.employee?.firstName +" "+ row?.employee?.lastName;
          },
        },
        {
          id: "projectTitle",
          label: "exportExcel.list.column.projectTitle",
          align: "left",
          width: "15vw",
          visible: true,
          renderCell: (row) => {
            return row?.task?.ticket?.project?.title;
          },
        },
        {
          id: "taskTitle",
          label: "exportExcel.list.column.taskTitle",
          align: "left",
          width: "15vw",
          visible: true,
          renderCell: (row) => {
            return row?.task?.title;
          },
        },
        {
          id: "description",
          label: "exportExcel.list.column.description",
          align: "left",
          width: "10vw",
          visible: true,
          renderCell: (row) => {
            return row?.description;
          },
        },
        {
          id: "date",
          label: "exportExcel.list.column.date",
          align: "center",
          visible: true,
          renderCell: (row) => {
           // return row?.date;
           return formatDateTimeToString(row?.startTime, false); ;
          },
        },
        {
          id: "duration",
          label: "exportExcel.list.column.duration",
          align: "center",
          visible: true,
          renderCell: (row) => {
            return row?.duration;
          },
        },
        {
          id: "billable",
          label: "exportExcel.list.column.billable",
          align: "left",
          width:"20vw",
          visible: true,
          renderCell: (row) => {
            let bool = row?.billable === "TRUE" || row?.billable === "True" || row?.billable === "true" || row?.billable === true ? true : false;
            return componentDisplay({compName: "IconBadge", compProps: {success: bool}});
          },
        },
       {id:"actions",
       align:"center",
       label:"exportExcel.list.column.action",
       visible:true,
       sticky:true,
       renderCell:(row) =>  { 
        return actions({compName:'EditRecord', compProps:row}); 
       },
      } 
      ],
      defaultSort: "employee",
      defaultSortDirection: "asc",
    };
  };
